//--------------------------------------------------------------------//
//******************** sip-trunks request helper ***********************//
//--------------------------------------------------------------------//
// Shared low-level fetch helper for talking to sip-gudhub-server's
// /sip-trunks REST API. Every route there is scoped to the trunk's
// owner_user_id/admins and requires the caller's GudHub token as an
// Authorization: Bearer header (see
// sip-gudhub-server/server/Authentication/requireAuth.js) - same pattern as
// gh_conversation/components/activityFeed/activityFeed.js.
import { GUDHUB_SETTINGS } from '../../../config.js';

export async function request(endpoint, options = {}) {
    const url = GUDHUB_SETTINGS.sip_server_url + endpoint;
    const token = await gudhub.getToken();

    const response = await fetch(url, {
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        ...options
    });

    if (response.status === 204) {
        return null;
    }

    const result = await response.json();

    if (!response.ok) {
        throw new Error(result.message || 'SIP trunks service request error');
    }

    return result;
}
